import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankName = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankName },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();
  const fieldHasError = error && !dataField.valueTankName;

  return (
    <TextInput
      label={tankName}
      value={dataField.valueTankName}
      validation={fieldHasError ? 'error' : undefined}
      feedback={fieldHasError ? fieldRequiredMessage : undefined}
      onChange={(value) =>
        setDataField({ ...dataField, valueTankName: value })
      }
    />
  );
};

TankName.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankName;
